<template>
  <section
    :id="message._id"
    ref="chatMessage"
    class="message message--chat"
    :class="{'hide': removedBookmark}"
  >
    <header class="message__metadata message__details-wrapper">
      <div class="message__metadata-info">
        <i>
          Chat site:
          <a
            :href="getMessageSearchHrefWithNewFilters([
              { mode: '+', type: 'site_name', term: `${message._source.site_name}` },
            ])"
            @click="addFilters([
              { mode: '+', type: 'site_name', term: `${message._source.site_name}` },
            ], $event)"
          >
            <span>{{ message._source.site_name }}</span>
          </a>
          <actions-menu
            :message="message"
            :noteId="message._source.site_id"
            :noteName="message._source.site_name"
            :siteLink="chatSiteLink"
            :filterTerm="message._source.site_name"
            :filterType="'site_name'"
            :noteItem="'chat site'"
            :hasNotes="message._source.has_chat_site_notes"
            :indexType="'chat'"
            @refresh="refresh"
            @bookmarkRemoved="bookmarkRemoved"
          />
          <a
            :href="`${chatTimelineUrl}${message._source.site_name}/${message._id}`"
          >
            <img
              src="/images/icons/see_in_context.svg"
              class=""
              title="See in context"
            >
          </a>
        </i>
        <details class="message__details u-mt-sm">
          <summary class="message__details--chat">
            Message details
          </summary>
          <dl class="dl-table dl-table--dense u-mt-sm u-mb-0 u-pl-md">
            <div class="dl-table__row">
              <dt>{{ gettext('Score:') }}</dt>
              <dd>{{ message._score }}</dd>
            </div>
            <div class="dl-table__row">
              <dt>{{ gettext('Message length:') }}</dt>
              <dd>{{ message._source.message.length }}</dd>
            </div>
            <div class="dl-table__row">
              <dt>{{ gettext('Doc ID:') }}</dt>
              <dd>{{ message._source.uuid }}</dd>
            </div>
          </dl>
        </details>
      </div>
      <div
        v-if="hasProcessMessagesPerms"
        class="message__update_processed_date"
        title="A message is processed after it's media been sent to Arachnid."
      >
        Processed
        <input
          :id="'process-' + message._id"
          type="checkbox"
          :checked="message._source.processed_date != null"
          @change="updateMessageProcessed(message)"
        >
        <label :for="'process-' + message._id" />
      </div>
      <div class="message__metadata-onion">
        <img
          title="This is a chat found on the Tor network"
          width="50"
          src="/static/images/logos/onion.png"
        >
      </div>
    </header>
    <div class="message__header">
      <p class="u-m-0">
        {{ pgettext('noting author of message', 'by') }}
        <a
          v-if="message._source.username"
          :href="getMessageSearchHrefWithNewFilters([
              { mode: '+', type: 'username', term: `${message._source.username}` },
          ])"
          @click="addFilters([
            { mode: '+', type: 'username', term: `${message._source.username}` },
          ], $event)"
        >
          <span><b>{{ message._source.username }}</b></span>
        </a>
        <i v-else>{{ pgettext('(unknown)') }}</i>
        <actions-menu
          :message="message"
          :noteId="message._source.site_id"
          :siteLink="userLink"
          :noteName="message._source.username"
          :filterTerm="message._source.username"
          :filterType="'username'"
          :noteItem="'chat user'"
          :hasNotes="message._source.has_chat_user_notes"
          :indexType="'chat'"
          :showBookmark="false"
          @refresh="refresh"
          @bookmarkRemoved="bookmarkRemoved"
        />
        {{ pgettext('noting date of message', 'on') }}
        <time datetime="">
          {{ readableDate(message._source.posted_date) }}
        </time>
        )
        <a
          class="u-pl-sm"
          :href="`/en/user/detail/${message._source.username}/${message._source.site_name}`"
        >
          View Username Details
          <svg
            class="icon u-fill-current u-fontsize-sm"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 100 100"
          >
            <path d="M47 2L35 14l27 27-40-1H6v20h16l40-1-27 27 12 12 48-48z" />
          </svg>
        </a>
      </p>
    </div>
    <message-result-body
      messageType="chat"
      :message="message"
      :indexType="'chat'"
      :hasNotes="message._source.has_chat_message_notes"
      @toggle-post="keepMessageInView"
      @refresh="refresh"
    />
    <message-result-details
      v-if="message._source.has_media !== false"
      :docId="message._id"
      :mediaSearchUrl="mediaSearchUrl"
      :messageSource="message"
      :indexType="'chat'"
    />
  </section>
</template>
<script>
import MessageResultBody from './MessageResultBody'
import MessageResultDetails from './MessageResultDetails'
import ActionsMenu from '../ActionsMenu'
import {getMessageSearchHrefWithNewFilters} from '../utils'
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'MessageResultChat',
  components: {
    MessageResultBody,
    MessageResultDetails,
    ActionsMenu
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    mediaSearchUrl: {
      type: String,
      default: ''
    },
    chatTimelineUrl: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      note: '',
      noteType: '',
      noteCategory: '',
      chatSiteLink: null,
      userLink: null,
      removedBookmark: false,
      hasProcessMessagesPerms: false,
    }
  },
  computed: {
    siteSourceCheck() {
      if (this.message._source.site) {
        if (this.message._source.site.includes('.onion')) {
          return true
        }
      }
      return false
    },
  },
  mounted() {
    this.chatSiteLink = new URL(this.chatTimelineUrl + this.message._source.site_name + '/', document.baseURI).href
    this.userLink = new URL('/en/message-search/?filters=site_name:' + this.message._source.site_name + ',username:' +
        this.message._source.username, document.baseURI).href
    this.hasProcessMessagesPerms = window.process_messages_perm
  },
  methods: {
    readableDate(timestamp) {
      let datetime = new Date(timestamp * 1000)
      // Include both date and time for chat messages
      return `${datetime.toLocaleDateString('en-GB', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })} ${datetime.toLocaleTimeString('en-GB')}`
    },
    getMessageSearchHrefWithNewFilters(filters) {
      return getMessageSearchHrefWithNewFilters(filters)
    },
    addFilters(filters, event) {
      if (event && !event.ctrlKey) {
        event.preventDefault()
        this.$store.commit('addFilters', filters)
      }
    },
    refresh() {
      this.$emit('refreshed')
    },
    keepMessageInView(isShowing) {
      let messageBounds = this.$el.getBoundingClientRect()

      if (isShowing && messageBounds.top < 0) {
        let y = (window.pageYOffset + messageBounds.top) - 10
        let x = 0

        // Keep the message in view on the page when collapsing it:
        window.scrollTo({
          top: y,
          left: x,
          behavior: 'smooth'
        })
      }
    },
    bookmarkRemoved() {
      let filters = this.$store.state.filters
      if (filters.length > 0) {
        filters.forEach(filter => {
          if (filter.type === 'bookmarked') {
            this.removedBookmark = true
            this.$refs.chatMessage.addEventListener('animationend', () => {
              this.$emit('bookmarkRemoved')
            })
          }
        })
      }
      return false
    },
    updateMessageProcessed(message) {
      const csrftoken = Cookies.get('csrftoken')
      const hasProcessedDate = message._source.processed_date != null
      const requestParams = {
        'doc_id': message._id,
        'current_processed_date': hasProcessedDate ? message._source.processed_date : '',
        'index': message._index
      }
      axios.post(
        '/en/message-search/processed_state/update/',
        requestParams,
        {'headers': {'X-CSRFToken': csrftoken}},
      ).then(response => {
        if (response.status === 200) {
          console.log(response)
          // request was a success so update the checkmark state
          message._source.processed_date = response.data.processed_date
          // hide the message
          const params = new URLSearchParams(window.location.search)
          const urlFilters = params.get('filters')
          if (urlFilters?.includes('processed_date')) {
            document.getElementById(message._id)?.classList.add('hidden')
          }
        }
      }).catch(e => {
        console.error(e) // nothing special to do with error
      })
    },
  }
}
</script>
<style scoped>
.hide {
  animation-name: fadeOutBookmark;
  animation-duration: 1s;
  animation-delay: 0.5s;
}
@keyframes fadeOutBookmark {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
section.hidden {
  display: none;
}
.watchlist-btn {
  padding-left: 10px;
}
.message__details--chat {
  cursor: pointer;
}
.message__update_processed_date {
  grid-column: 2;
  padding-top: 0.25em;
  padding-left: 0.5em;
  text-align: center;
}
.message__update_processed_date > label {
  left: 50%;
  margin-left: -10px;
  height: 50px;
}
</style>
